var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Box" },
    [
      _c(
        "el-card",
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "HUB1", name: "first" } },
                [
                  _c("hubOne", {
                    ref: "hub1",
                    on: { detailData: _vm.getDetailPage },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "HUB2/3", name: "second" } },
                [
                  _c("hubTwoThree", {
                    ref: "hub2",
                    on: { detailData: _vm.getDetailPage },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          ref: "drawer",
          attrs: {
            title: _vm.titleName,
            visible: _vm.msgDrawer,
            direction: "ltr",
            size: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.msgDrawer = $event
            },
            close: _vm.cancelForm,
          },
        },
        [
          _c(
            "div",
            { staticStyle: { margin: "20px" } },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: { "flex-wrap": "wrap" },
                      attrs: { type: "flex", justify: "left" },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "运单号(número de waybill)" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "95%" },
                                attrs: {
                                  placeholder:
                                    "精确搜索，一行一项，最多支持2000行(A pesquisa exata, uma linha de cada vez, suporta até 2000 linhas)",
                                  rows: 1,
                                  type: "textarea",
                                },
                                on: { blur: _vm.BlockNewline },
                                nativeOn: {
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.BlockNewline($event)
                                  },
                                },
                                model: {
                                  value: _vm.inputValue,
                                  callback: function ($$v) {
                                    _vm.inputValue = $$v
                                  },
                                  expression: "inputValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "丢损类型(Tipo)" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "95%" },
                                  attrs: {
                                    placeholder: "请选择(Favor selecionar)",
                                    multiple: "",
                                    "collapse-tags": "",
                                  },
                                  model: {
                                    value:
                                      _vm.queryForm.params.responsibilityTypes,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "responsibilityTypes",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.responsibilityTypes",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "确认丢失(Perda confirmada)",
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label:
                                        "被抢或被盗(Pacote roubado/furtado)",
                                      value: 2,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: "破损(Pacote avariado)",
                                      value: 3,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "责任网点(Ponto responsável)" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "95%" },
                                  attrs: {
                                    placeholder: "请选择(Favor selecionar)",
                                    clearable: "",
                                    filterable: "",
                                    multiple: "",
                                    "collapse-tags": "",
                                  },
                                  model: {
                                    value: _vm.queryForm.params.siteIds,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "siteIds",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.siteIds",
                                  },
                                },
                                _vm._l(_vm.siteIdList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "20px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "", size: "small" },
                      on: { click: _vm.searchMsg },
                    },
                    [_vm._v("查询(Consultar)")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.exportMsg },
                    },
                    [_vm._v("导出(Exportar)")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    border: "",
                    "max-height": "600",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号(No.)",
                      align: "center",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  (_vm.queryForm.pageNumber - 1) *
                                    _vm.queryForm.pageSize +
                                    scope.$index +
                                    1
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "运单号(Número de waybill)",
                      prop: "waybillNumber",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "定责时间(Tempo de Responsabilidade)",
                      prop: "responsibilityTime",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "丢损类型(Tipo)",
                      prop: "responsibilityTypeName",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "责任网点(Ponto responsável)",
                      prop: "siteName",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c("el-pagination", {
                    staticStyle: { margin: "10px 0" },
                    attrs: {
                      layout: "total, sizes, prev, pager, next, jumper",
                      "current-page": _vm.queryForm.pageNumber,
                      "page-sizes": [10, 20, 50, 100, 500, 1000],
                      "page-size": _vm.queryForm.pageSize,
                      total: _vm.total,
                      background: "",
                    },
                    on: {
                      "update:currentPage": function ($event) {
                        return _vm.$set(_vm.queryForm, "pageNumber", $event)
                      },
                      "update:current-page": function ($event) {
                        return _vm.$set(_vm.queryForm, "pageNumber", $event)
                      },
                      "update:pageSize": function ($event) {
                        return _vm.$set(_vm.queryForm, "pageSize", $event)
                      },
                      "update:page-size": function ($event) {
                        return _vm.$set(_vm.queryForm, "pageSize", $event)
                      },
                      "current-change": _vm.getDatePage,
                      "size-change": _vm.searchMsg,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }